'use strict';

import $ from 'jquery';
import 'jquery-validation';

$.validator.addMethod(
  'notOnlyZero',
  function (value, element, param) {
    return this.optional(element) || parseInt(value) > 0;
  },
  'Campo obrigatório.'
);

$.validator.addMethod(
  'strong_password',
  function (value, element) {
    let password = value;
    if (document.body.getAttribute('data-action') == 'create' || (document.body.getAttribute('data-action') == 'edit' && password.length)) {
      if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%&*()!^-_{}])(.{8,20}$)/.test(password)) {
        return false;
      }
    }
    return true;
  },
  function (value, element) {
    let password = $(element).val();
    if (!/^(.{8,20}$)/.test(password)) {
      return 'A senha deve conter entre 8 e 20 caracteres.';
    } else if (!/^(?=.*[A-Z])/.test(password)) {
      return 'A senha deve conter ao menos uma letra maiúscula.';
    } else if (!/^(?=.*[a-z])/.test(password)) {
      return 'A senha deve conter ao menos uma letra minúscula.';
    } else if (!/^(?=.*[0-9])/.test(password)) {
      return 'A senha deve conter ao menos um número.';
    } else if (!/^(?=.*[@#$%&*()!^-_{}])/.test(password)) {
      return 'A senha deve conter ao menos um caractere especial (@#$%&*()!^-_{}).';
    }
    return false;
  }
);

$.validator.addMethod(
  'filesize',
  function (value, element, param) {
    return this.optional(element) || element.files[0].size <= param * 1000000;
  },
  'Arquivo muito grande. Por favor, insira arquivo até {0}MB.'
);

$.validator.methods.email = function (value, element) {
  return this.optional(element) || /^.+@.+\..+$/.test(value);
};

export const validator = (form, rules) => {
  $(form)
    .on('submit', function (e) {
      e.preventDefault();
    })
    .validate({
      ...rules,
      highlight: function (element, errorClass, validClass) {
        var elem = $(element);
        if (elem.hasClass('select2-hidden-accessible')) {
          $('#select2-' + elem.attr('id') + '-container')
            .parent()
            .addClass(errorClass);
        } else {
          elem.addClass(errorClass);
        }
      },
      unhighlight: function (element, errorClass, validClass) {
        var elem = $(element);
        if (elem.hasClass('select2-hidden-accessible')) {
          $('#select2-' + elem.attr('id') + '-container')
            .parent()
            .removeClass(errorClass);
        } else {
          elem.removeClass(errorClass);
        }
      },
      errorPlacement: function (error, element) {
        var elem = $(element);
        if (elem.hasClass('select2-hidden-accessible')) {
          element = $('#select2-' + elem.attr('id') + '-container').parent();
          error.insertAfter(element);
        } else if (element.is(':radio')) {
          error.appendTo(element.closest('.radio-container'));
        } else if (element.is(':checkbox')) {
          error.appendTo(element.closest('.check-container'));
        } else {
          error.insertAfter(element);
        }
      },
      submitHandler: function (form) {
        form.submit();
      },
    });

  $(document).on('change', '[data-custom-file]', function (e) {
    $(this).valid();
  });

  $(document).on('change', '.select2-hidden-accessible', function (e) {
    $(this).valid();
  });
};
